/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Green flag execution order",
  "description": "Shows numbered badges next to green flag blocks indicating the order they will be executed when the green flag is clicked. Numbers are based on the actual execution order: Stage scripts run last, followed by sprites in reverse layer order.",
  "tags": ["editor"],
  "credits": [
    {
        "name": "Mistium",
        "url": "https://mistium.com"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Badge style",
      "id": "badge_style",
      "type": "select",
      "potentialValues": [
        {
          "name": "Circular badge",
          "id": "circle"
        },
        {
          "name": "Square badge", 
          "id": "square"
        }
      ],
      "default": "circle"
    },
    {
      "dynamic": true,
      "name": "Badge color",
      "id": "badge_color",
      "type": "color",
      "default": "#4CAF50"
    },
    {
      "dynamic": true,
      "name": "Text color",
      "id": "text_color", 
      "type": "color",
      "default": "#FFFFFF"
    }
  ],
  "enabledByDefault": false
};
export default manifest;
